import React, { useState, useEffect } from 'react';
import './App.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap-icons/font/bootstrap-icons.css';

import imagenLamina from './assets/lamina_porcelanizada.jpeg';
import imgeEsmaltada from './assets/acceso_esmaltada.png'
import imageSolido from './assets/solido.jpeg'
import imageTroqueladas from './assets/acceso_troqueladas.jpeg'
import imageMamparaSolido from './assets/mampara_solido.jpeg'
import imageAcero from './assets/acero_porcelanizado.jpeg'
import imageAceroEsmaltado from './assets/acero_esmaltado.jpeg'
import imagePizarron from './assets/pizarron.jpeg'
import imagePanel from './assets/panel.jpeg'
import imagePanelSolido from './assets/panel_solido.jpeg'

const FaqItem = ({ question, answer }) => {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <div className="accordion-item">
      <h2 className="accordion-header">
        <button
          className={`accordion-button ${!isOpen ? 'collapsed' : ''}`}
          type="button"
          onClick={() => setIsOpen(!isOpen)}
        >
          {question}
        </button>
      </h2>
      <div className={`accordion-collapse collapse ${isOpen ? 'show' : ''}`}>
        <div className="accordion-body">
          {answer}
        </div>
      </div>
    </div>
  );
};

function App() {
  const [isScrolled, setIsScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);



  return (
    <div className="App">
      {/* NAVBAR */}
      <nav className={`navbar navbar-expand-lg fixed-top ${isScrolled ? 'navbar-glass text-dark-nav py-2' : 'bg-transparent text-white-nav py-4'
        }`}>
        <div className="container">
          <a className="navbar-brand fs-3" href="#">SIMAP</a>
          <div className="collapse navbar-collapse justify-content-end">
            <ul className="navbar-nav">
              <li className="nav-item"><a className="nav-link" href="#catalogo">Catálogo</a></li>
              <li className="nav-item"><a className="nav-link" href="#nosotros">Nosotros</a></li>
              <li className="nav-item"><a className="nav-link" href="#faq">FAQs</a></li>
            </ul>
          </div>
        </div>
      </nav>

      <header className="hero-container">
        <div className="container">
          <h1 className="display-1 fw-bold">Puertas y Mamparas Modernas</h1>
          <p className="fs-3 mb-5">Soluciones contemporáneas con visión arquitectónica.</p>
        </div>
      </header>

      <section id="catalogo" className="py-5">
        <div className="container">
          <div className="text-center mb-5">
            <h2 className="display-4 fw-bold">Nuestro Catálogo</h2>
            <p className="text-muted fs-5">Materiales premium diseñados para resistir y destacar.</p>
          </div>

          <div className="row g-4">
            <div className="col-md-6 col-lg-4">
              <div className="catalog-card">
                <div className="img-container">
                  <span className="catalog-badge">Más Vendido</span>
                  <img
                    src={imagenLamina}
                    alt="Lamina Porcelanizada"
                    className="catalog-img"
                  />
                </div>
                <div className="catalog-body">
                  <h3 className="catalog-title">Puertas de Acceso de Lámina Porcelanizada</h3>
                  <p className="text-muted small">Resistencia, seguridad y acabado moderno en una solución duradera y de bajo mantenimiento.</p>
                  <a href="https://wa.me/5530809525" className="btn btn-outline-primary btn-sm rounded-pill">Cotizar ahora</a>
                </div>
              </div>
            </div>
            <div className="col-md-6 col-lg-4">
              <div className="catalog-card">
                <div className="img-container">
                  <span className="catalog-badge">Premium</span>
                  <img
                    src={imgeEsmaltada}
                    alt="Acceso Esmaltadas"
                    className="catalog-img"
                  />
                </div>
                <div className="catalog-body">
                  <h3 className="catalog-title">Puertas de Acceso Esmaltadas</h3>
                  <p className="text-muted small">Una opción práctica y accesible, con un acabado funcional que ofrece buena presencia y protección a un precio competitivo.</p>
                  <a href="https://wa.me/5530809525" className="btn btn-outline-primary btn-sm rounded-pill">Cotizar ahora</a>
                </div>
              </div>
            </div>
            <div className="col-md-6 col-lg-4">
              <div className="catalog-card">
                <div className="img-container">
                  <span className="catalog-badge">Nuevo</span>
                  <img
                    src={imageSolido}
                    alt="Sólido Fenólico"
                    className="catalog-img"
                  />
                </div>
                <div className="catalog-body">
                  <h3 className="catalog-title">Puertas de Acceso en Sólido Fenólico</h3>
                  <p className="text-muted small">Diseño moderno, alta resistencia y durabilidad en una puerta pensada para el uso intensivo y el bajo mantenimiento.</p>
                  <a href="https://wa.me/5530809525" className="btn btn-outline-primary btn-sm rounded-pill">Cotizar ahora</a>
                </div>
              </div>
            </div>
            <div className="col-md-6 col-lg-4">
              <div className="catalog-card">
                <div className="img-container">
                  <span className="catalog-badge">Popular</span>
                  <img
                    src={imageTroqueladas}
                    alt="Acceso Troqueladas"
                    className="catalog-img"
                  />
                </div>
                <div className="catalog-body">
                  <h3 className="catalog-title">Puertas de Acceso Troqueladas</h3>
                  <p className="text-muted small">Carácter y resistencia en cada detalle, con acabados durables y una estética distintiva que aporta seguridad y presencia a cualquier espacio.</p>
                  <a href="https://wa.me/5530809525" className="btn btn-outline-primary btn-sm rounded-pill">Cotizar ahora</a>
                </div>
              </div>
            </div>
            <div className="col-md-6 col-lg-4">
              <div className="catalog-card">
                <div className="img-container">
                  <span className="catalog-badge">Premium</span>
                  <img
                    src={imageMamparaSolido}
                    alt="Mamparas En Sólido Fenólico"
                    className="catalog-img"
                  />
                </div>
                <div className="catalog-body">
                  <h3 className="catalog-title">Mamparas En Sólido Fenólico</h3>
                  <p className="text-muted small">Máxima resistencia a la humedad y químicos. Perfecto para gimnasios, hospitales y escuelas.</p>
                  <a href="https://wa.me/5530809525" className="btn btn-outline-primary btn-sm rounded-pill">Cotizar ahora</a>
                </div>
              </div>
            </div>
            <div className="col-md-6 col-lg-4">
              <div className="catalog-card">
                <div className="img-container">
                  <span className="catalog-badge">Popular</span>
                  <img
                    src={imageAcero}
                    alt="Acero Porcelanizado"
                    className="catalog-img"
                  />
                </div>
                <div className="catalog-body">
                  <h3 className="catalog-title">Mamparas en Acero Porcelanizado</h3>
                  <p className="text-muted small">Solución práctica y estética que brinda privacidad, durabilidad y un acabado profesional para espacios de alto uso.</p>
                  <a href="https://wa.me/5530809525" className="btn btn-outline-primary btn-sm rounded-pill">Cotizar ahora</a>
                </div>
              </div>
            </div>
            <div className="col-md-6 col-lg-4">
              <div className="catalog-card">
                <div className="img-container">
                  <span className="catalog-badge">Más vendido</span>
                  <img
                    src={imageAceroEsmaltado}
                    alt="Acero Esmaltado"
                    className="catalog-img"
                  />
                </div>
                <div className="catalog-body">
                  <h3 className="catalog-title">Mamparas en Acero Esmaltado</h3>
                  <p className="text-muted small">Una alternativa funcional y accesible, ideal para proyectos que buscan practicidad y buena presentación a un costo competitivo.</p>
                  <a href="https://wa.me/5530809525" className="btn btn-outline-primary btn-sm rounded-pill">Cotizar ahora</a>
                </div>
              </div>
            </div>
            <div className="col-md-6 col-lg-4">
              <div className="catalog-card">
                <div className="img-container">
                  <span className="catalog-badge">Popular</span>
                  <img
                    src={imagePizarron}
                    alt="Pizarrón"
                    className="catalog-img"
                  />
                </div>
                <div className="catalog-body">
                  <h3 className="catalog-title">Panel Arquitectónico Tipo Pizarrón</h3>
                  <p className="text-muted small">Elemento arquitectónico funcional que aporta diseño, continuidad visual y una superficie útil de escritura, integrándose de forma elegante a espacios modernos.</p>
                  <a href="https://wa.me/5530809525" className="btn btn-outline-primary btn-sm rounded-pill">Cotizar ahora</a>
                </div>
              </div>
            </div>

            <div className="col-md-6 col-lg-4">
              <div className="catalog-card">
                <div className="img-container">
                  <span className="catalog-badge">Premium</span>
                  <img
                    src={imagePanel}
                    alt="Panel Arquitectónico"
                    className="catalog-img"
                  />
                </div>
                <div className="catalog-body">
                  <h3 className="catalog-title">Panel Arquitectónico Porcelanizado o esmaltado</h3>
                  <p className="text-muted small">Recubrimiento funcional y estético que aporta continuidad visual, durabilidad y un acabado moderno para integrarse de forma elegante a cualquier espacio.</p>
                  <a href="https://wa.me/5530809525" className="btn btn-outline-primary btn-sm rounded-pill">Cotizar ahora</a>
                </div>
              </div>
            </div>
            <div className="col-md-6 col-lg-4">
              <div className="catalog-card">
                <div className="img-container">
                  <span className="catalog-badge">Nuevo</span>
                  <img
                    src={imagePanelSolido}
                    alt="Panel de Sólido Fenólico<"
                    className="catalog-img"
                  />
                </div>
                <div className="catalog-body">
                  <h3 className="catalog-title">Panel de Sólido Fenólico</h3>
                  <p className="text-muted small">Recubrimientos de alto desempeño que combinan resistencia, durabilidad y diseño contemporáneo, ideales para espacios que exigen funcionalidad y larga vida útil.</p>
                  <a href="https://wa.me/5530809525" className="btn btn-outline-primary btn-sm rounded-pill">Cotizar ahora</a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section id="nosotros" className="py-5 bg-light">
        <div className="container">
          <div className="text-center mb-5">
            <h2 className="display-4 fw-bold mb-4">Sobre Nosotros</h2>
            <p className="lead mx-auto mb-5" style={{ maxWidth: '700px' }}>
              En SIMAP, nos dedicamos a la fabricación y venta de mamparas sanitarias de alta calidad en acero porcelanizado, sólido fenolico y distintos materiales, ofreciendo soluciones prácticas y duraderas para espacios públicos y privados. Nuestro compromiso con la excelencia se refleja en cada producto que diseñamos, garantizando funcionalidad y estética en cada detalle.
            </p>
          </div>

          {/* LISTADO DE VALORES */}
          <div className="row g-4 justify-content-center">
            <div className="col-md-4">
              <div className="value-card text-center">
                <div className="value-icon">
                  <i className="bi bi-shield-check"></i>
                </div>
                <h4>Calidad Superior</h4>
                <p className="text-muted">Utilizamos materiales certificados que garantizan una larga vida útil incluso en condiciones de humedad extrema.</p>
              </div>
            </div>

            <div className="col-md-4">
              <div className="value-card text-center">
                <div className="value-icon">
                  <i className="bi bi-clock-history"></i>
                </div>
                <h4>Puntualidad</h4>
                <p className="text-muted">Respetamos los tiempos de entrega pactados, entendiendo que la eficiencia es clave para tus proyectos.</p>
              </div>
            </div>

            <div className="col-md-4">
              <div className="value-card text-center">
                <div className="value-icon">
                  <i className="bi bi-tools"></i>
                </div>
                <h4>Instalación Experta</h4>
                <p className="text-muted">Nuestro equipo técnico asegura una colocación precisa y segura, cuidando cada detalle estético y funcional.</p>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section id="faq" className="py-5 bg-light">
        <div className="container">
          <div className="text-center mb-5">
            <h2 className="display-4 fw-bold">Preguntas Frecuentes</h2>
            <p className="text-muted">Resolvemos tus dudas sobre nuestras mamparas</p>
          </div>

          <div className="row justify-content-center">
            <div className="col-lg-8">
              <div className="faq-section">
                <FaqItem
                  question="¿Qué son las mamparas sanitarias?"
                  answer="Son divisiones diseñadas específicamente para baños públicos y vestuarios, fabricadas con materiales que garantizan privacidad, higiene y resistencia al uso rudo."
                />
                <FaqItem
                  question="¿Qué diferencia hay entre acero porcelanizado y sólido fenólico?"
                  answer="El acero porcelanizado es muy duradero y económico para zonas secas. El sólido fenólico es el 'rey de la resistencia': aguanta impactos directos, humedad extrema y es totalmente antigrafiti."
                />
                <FaqItem
                  question="¿Hacen instalaciones en todo el país?"
                  answer="Sí, contamos con equipo especializado para realizar instalaciones profesionales, asegurando que el producto quede perfectamente nivelado y funcional."
                />
                <FaqItem
                  question="¿Cuál es el tiempo de entrega?"
                  answer="Dependiendo del material y el tamaño del proyecto, el tiempo promedio es de 10 a 15 días hábiles."
                />
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* FOOTER */}
      <footer className="footer-main pt-5">
        <div className="container">
          <div className="row g-4 pb-4">
            <div className="col-lg-4 col-md-6">
              <h3 className="fw-bold mb-3">SIMAP</h3>
              <p className="opacity-75">
                Expertos en soluciones de mamparas sanitarias con diseño moderno y durabilidad garantizada.
              </p>
            </div>
            <div className="col-lg-4 col-md-6 footer-column">
              <h5>Contacto y Ventas</h5>
              <div className="footer-info-item">
                <i className="bi bi-telephone-fill"></i>
                <div>
                  Ventas: 5530809525 | 5520104781<br />
                  Oficina: 5524812245
                </div>
              </div>
              <div className="footer-info-item">
                <i className="bi bi-envelope-at-fill"></i>
                <span>PROYECTOS_SIMAP@outlook.com</span>
              </div>
            </div>
            <div className="col-lg-4 col-md-12 footer-column">
              <h5>Ubicación y Horarios</h5>
              <div className="footer-info-item">
                <i className="bi bi-geo-alt-fill"></i>
                <span>C. La Guerrillera 328, Benito Juárez, 57000 Cdad. Nezahualcóyotl, Mex.</span>
              </div>
              <div className="footer-info-item">
                <i className="bi bi-clock-fill"></i>
                <span>Lun - Vie: 9am-6pm | Sab: 9am-2pm</span>
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col-12 text-center pb-4">
              <div className="promo-box d-inline-block p-3 rounded-4 bg-white bg-opacity-10 border border-white border-opacity-10">
                <p className="mb-2">¿Listo para llevar tu proyecto al siguiente nivel?</p>
                <a
                  href="https://3vertices.com.mx/"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="number-a fs-5 text-decoration-none"
                >
                  <i className="bi bi-globe me-2"></i>Conoce más en 3vertices.com.mx
                </a>
              </div>
            </div>
          </div>
        </div>
        <div className="footer-bottom-bar text-center">
          <div className="container">
            <p className="small mb-0 opacity-75">
              © {new Date().getFullYear()} SIMAP - Todos los derechos reservados.
            </p>
          </div>
        </div>
      </footer>

      {/* WHATSAPP */}
      <a href="https://wa.me/5530809525" className="whatsapp-button" target="_blank" rel="noreferrer">
        <i className="bi bi-whatsapp"></i>
      </a>
    </div>
  );
}

export default App;